// ADR-0013 (free-tier rescope): R-HOD, R-LOD, Bid Depth, and Ask Depth are
// paywalled. The API redacts them server-side (`null` values +
// `entitled: false`) for unentitled sessions; this module is the single
// client-side mapping from that payload signal to the locked presentation.
//
// The four gated slots keep their exact layout positions; only the value is
// replaced by LOCKED_TEXT in a dimmed/secondary style (see styles.css's
// `.locked-value`) -- never a fake/zero value, never styled like a live
// reading.

/** The Owner-decided locked-slot text (ADR-0013): the full phrase is the
 * default everywhere it fits, and it fits everywhere on this dashboard. */
export const LOCKED_TEXT = "Subscribers Only";

/** Payloads that carry the ADR-0013 entitlement flag. `entitled` is
 * optional: a payload WITHOUT the field is treated as entitled=true. That
 * is a deliberate transitional default -- until the backend's ADR-0013
 * redaction deploys, /v1/current, /v1/stream, and /v1/daily-extremes
 * responses have no `entitled` field at all and their gated fields are
 * real live values, so rendering them locked would be wrong. Once the
 * backend ships, unentitled sessions always get an explicit
 * `entitled: false` (plus nulled gated fields), which is the only signal
 * that renders the locked state. */
export interface Entitleable {
  entitled?: boolean;
}

export function isEntitled(payload: Entitleable): boolean {
  return payload.entitled !== false;
}
